import React from 'react';

const ICONS = { success: '✓', error: '✕', warning: '⚠', info: 'ℹ' };

function AppStatus({ status }) {
    if (!status) return null;
    return (
        <div className={`app-toast app-toast--${status.type}`}>
            <span className="app-toast__icon">{ICONS[status.type] || '•'}</span>
            <span className="app-toast__message">{status.message}</span>
        </div>
    );
}

export default AppStatus;
